import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { PicklistOptionsField } from "../../../Attributes/Fields/PicklistStringFields";
import { useState } from "react";
import { useTranslation } from "react-i18next";

// TODO: Add translation object for the following EditPicklistDialog component
function EditPicklistDialog({ attribute, onClose, onSubmit, onCancel, title = "Edit Dropdown Values", addOptionText = "Dropdown Value" }) {

    const { t } = useTranslation();

    const SEPARATOR = 'ɖ';

    const defaultPicklist = attribute.picklist;

    const picklistInDesignerFormat = defaultPicklist.join(SEPARATOR);
    const [picklist, setPicklist] = useState(picklistInDesignerFormat);
    const [isPicklistValid, setIsPicklistValid] = useState(false);

    function handleClose() {
        onClose();
    }

    function handleSubmit() {
        onSubmit(picklist.split(SEPARATOR));
    }

    function handleCancel() {
        onCancel();
    }

    function handlePicklistChange(event) {
        setPicklist(event.target.value);
        const isValid = validatePicklist(event.target.value);
        setIsPicklistValid(isValid);
    }

    function validatePicklist(picklistValue) {
        const picklist = picklistValue.split(SEPARATOR);
        const duplicate = picklist.some((item, itemIndex) => (
            picklist.some((other, otherIndex) => (
                item.trim().toLowerCase() === other.trim().toLowerCase() && itemIndex !== otherIndex
            ))
        ));
        const hasEmpty = picklist.some(item => item !== undefined && item.trim() === '');
        const hasPicklistSame = picklistInDesignerFormat === picklistValue;
        return picklist.length > 0 && !duplicate && !hasEmpty && !hasPicklistSame;
    }

    return (
        <Dialog
            title={title}
            onClose={handleClose}
            height={420}
        >
            <div className="h-100">
                <PicklistOptionsField
                    showScrollable={true}
                    addDropdownButtonText={addOptionText}
                    onChange={handlePicklistChange}
                    value={picklist}
                    onErr={() => { }} />
            </div>
            <DialogActionsBar layout="end">
                <div className='mb-4 me-3 pe-2'>
                    <button className="btn" onClick={handleCancel}>
                        {t("edit_picklist_dialog.buttons.cancel_label") }
                    </button>
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={!isPicklistValid}>
                        {t("edit_picklist_dialog.buttons.save_label") }
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}

export default EditPicklistDialog;